<template>
  <div>
    <div id="modalTransportistas" class="modal">
      <div class="modal-contenido rounded-xl p-1">
        <div class="grid grid-cols-6 justify-items-end">
          <button
            @click="clean()"
            type="button"
            class="col-start-6 end text-xl mx-2 p-1"
          >
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="w-full">
          <h4
            class="bg-gray-100 mx-9 mb-1 text-2xl shadow-xl text-black text-center mt-1 rounded divide-y divide-red-500"
          >
            Transportistas
            <hr color="black" size="4" />
          </h4>
        </div>
        <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
        <div class="uppercase">
          <div class="grid grid-cols-2 mt-5">
            <div class="col-span-1 mx-2">
              <strong v-if="valor">nombre</strong>
              <p
                class="divide divide-y mx-2 border-b-2 divide-black"
                v-if="!banderamodal"
              >
                <strong v-if="!valor"> {{ nombres }} </strong>
              </p>

              <input
                v-model="nombre"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="text"
                placeholder="Nombre  "
              />
              <input
                v-model="nombre"
                v-on:keyup="mostrar()"
                v-if="banderamodal"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="text"
                placeholder="Nombre 1 "
              />
            </div>
            <div class="col-span-1 mx-2">
               <strong v-if="valor">telefono</strong>
              <p
                class="divide divide-y mx-2 border-b-2 divide-black"
                v-if="!banderamodal"
              >
                <strong v-if="!valor"> {{ telefonos }} </strong>
              </p>

              <input
                v-model="telefono"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="number"
                placeholder="Telefono "
              />
              <input
                v-model="telefono"
                v-on:keyup="mostrar()"
                v-if="banderamodal"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="number"
                placeholder="Telefono "
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong v-if="valor">telefono</strong>
              <p
                class="divide divide-y mx-2 border-b-2 divide-black"
                v-if="!banderamodal"
              >
                <strong v-if="!valor"> {{ direccions }} </strong>
              </p>

              <input
                v-model="direccion"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="text"
                placeholder="Direccion "
              />
              <input
                v-model="direccion"
                v-on:keyup="mostrar()"
                v-if="banderamodal"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="text"
                placeholder="Direccion "
              />
            </div>
            <div class="col-span-1 mx-2">
              <strong v-if="valor">Correo</strong>
              <p
                class="divide divide-y mx-2 border-b-2 divide-black"
                v-if="!banderamodal"
              >
                <strong v-if="!valor"> {{ correos }} </strong>
              </p>
              <input
                v-model="correo"
                v-on:keyup="mostrar()"
                v-if="valor"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="text"
                placeholder="Correo   "
              />
              <input
                v-model="correo"
                v-on:keyup="mostrar()"
                v-if="banderamodal"
                class="appearance-none mx-2 border shadow-xl block bg-gray-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
                id=""
                type="text"
                placeholder="Correo   "
              />
            </div>
          </div>

          <div class="inline flex justify-center">
            <div>
              <button
                v-if="!banderamodal"
                @click="mostrarinicial()"
                type="button"
                class="w-full inline-flex justify-center mt-5 rounded-md border border-transparent shadow-sm px-2 py-1 bg-green-400 text-base font-medium text-white hover:bg-green-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Modificar
              </button>
            </div>
            <div class="col-span-1 mx-2">
              <button
                @click="agregartable(), clean(),recargar()"
                type="button"
                class="w-full inline-flex justify-center mt-5 rounded-md border border-transparent shadow-sm px-2 py-1 bg-blue-600 text-base font-medium text-white hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                <a href="#"> Guardar </a>
              </button>
            </div>
          </div>
        </div>
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
//import axios from "axios";
export default {
  name: "modalTransportistas",
  data() {
    return {
      caracteristica: "",
      respuesta: null,
      idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      nombre: "",
      telefono: "",
      direccion: "",
      correo: "",
      usuario: "",
      valor: false,
    };
  },

  methods: {
    ...mapMutations("transportistas", ["agregartable", "cambio",'cargardatostransportistas']),

    mostrar() {
      var datos = {
        nombre: this.nombre,
        telefono: this.telefono,
        direccion: this.direccion,
        correo: this.correo,
      };

      this.cambio(datos);
    },
     async recargar() {
      setTimeout(() => {
        this.cargardatostransportistas();
      }, 500);
    },
    mostrarinicial() {
      this.nombre = this.nombres;
      this.correo = this.correos;
      this.telefono = this.telefonos;
      this.direccion = this.direccions;
      this.valor = true;
    },

    clean() {
      this.nombre = null;
      this.direccion = null;
      this.correo = null;
      this.telefono = null
      this.descripcion = null;
      this.valor = false;
    },
  },
  computed: {
    ...mapState("transportistas", [
      "idmodal",
      "descripcionmodal",
      "nombres",
      "direccions",
      "correos",
      "telefonos",
      'transportistas'
    ]),
    ...mapState([
      "elemento",
      "id",
      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 170px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalTransportistas:target {
  opacity: 1;
  pointer-events: auto;
}
</style>

